// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Розсилки» (Newsletters, ключ `nws`, група `communications`). */
export const newslettersManifest: IModuleManifest = {
  key: 'nws',
  group: 'communications',
  slug: 'newsletters',
  prefix: 'NWS',
  name: { en: 'Newsletters', uk: 'Розсилки' },
  entities: [
    { key: 'nws', slug: 'nws', name: { en: 'Newsletters', uk: 'Розсилки' }, main: true },
    { key: 'newsletter_send', slug: 'newsletter-send', name: { en: 'Newsletter Sends', uk: 'Розсилки' }, main: false },
    { key: 'newsletter_recipient', slug: 'newsletter-recipient', name: { en: 'Newsletter Recipients', uk: 'Одержувачі' }, main: false },
    { key: 'newsletter_opt_out', slug: 'newsletter-opt-out', name: { en: 'Newsletter Opt-outs', uk: 'Відмови від розсилки' }, main: false },
  ],
  loadState: () => import('./state/newslettersSlice').then((m) => m.newslettersSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
